import React from 'react';
import moment from 'moment';

export default function AgeCell({ birthDate }) {
  return <span>{moment().diff(birthDate, 'years')}</span>;
}
